import { useSyncExternalStore } from "react";

const SESSION_KEY = "lustbucket-session";
const EMAIL_KEY = "lustbucket-email";
const listeners = new Set<() => void>();

function notify() {
  listeners.forEach((listener) => listener());
}

function subscribe(callback: () => void) {
  listeners.add(callback);
  return () => {
    listeners.delete(callback);
  };
}

function getSnapshot(): number | null {
  const value = localStorage.getItem(SESSION_KEY);
  if (!value) {
    return null;
  }

  const parsed = Number(value);
  return Number.isNaN(parsed) ? null : parsed;
}

function getServerSnapshot(): number | null {
  return null;
}

export function useSession() {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

export function useSessionEmail() {
  return useSyncExternalStore(
    subscribe,
    () => localStorage.getItem(EMAIL_KEY),
    () => null,
  );
}

export function setSession(userId: number, email: string) {
  localStorage.setItem(SESSION_KEY, String(userId));
  localStorage.setItem(EMAIL_KEY, email);
  notify();
}

export function clearSession() {
  localStorage.removeItem(SESSION_KEY);
  localStorage.removeItem(EMAIL_KEY);
  notify();
}
